export enum FieldTypeEnum {
  String = 'string',
  Text = 'text',
  Single = 'single',
  Multi = 'multi',
  Time = 'time',
  Attachment = 'attachment',
  Product = 'product',
  Describe = 'describe',
  PageBreak = 'page_break',
  Date = 'date',
  Integer = 'integer',
  DateRange = 'date-range',
  Address = 'address',
}
